import React from 'react';
import SKUManagement from './SKUManagement';
import SupplierManagement from './SupplierManagement';
import ProjectDetails from './ProjectDetails';

/**
 * Settings Module - Main Container
 * Manages the Settings section with tabs for SKU, Suppliers, and Project Details
 */
const SettingsModule = React.memo(({
    activeSettingsTab,
    setActiveSettingsTab,
    // SKU Management props
    searchTerm,
    setSearchTerm,
    filteredInventory,
    priceLogs,
    can,
    setIsCategoryModalOpen,
    setSelectedItem,
    setIsItemModalOpen,
    setViewingImage,
    setSelectedItemForPriceLog,
    setShowPriceLogModal,
    requestConfirm,
    db,
    fetchData,
    // Supplier Management props
    suppliers,
    setEditingSupplier,
    setIsSupplierModalOpen,
    // Project Details props
    activeProject,
    selectedProjectIcon,
    setSelectedProjectIcon,
    setConfirmModal,
    showToast,
    setIsDeleteProjectModalOpen,
    setDeleteProjectPassword,
    setDeleteProjectError
}) => {
    return (
        <div className="space-y-6 md:space-y-8">
            {/* Settings Tabs - Scrollable on mobile */}
            <div className="flex p-1 bg-white rounded-2xl border border-slate-100 shadow-sm overflow-x-auto no-scrollbar w-full md:w-fit">
                <button 
                    className={`px-4 sm:px-6 py-2.5 rounded-xl text-xs sm:text-sm font-bold transition-all whitespace-nowrap flex-shrink-0 ${
                        activeSettingsTab === 'sku' 
                            ? 'bg-emerald-500 text-white shadow-md' 
                            : 'text-slate-500 hover:text-slate-700'
                    }`} 
                    onClick={() => setActiveSettingsTab('sku')}
                >
                    Pengurusan SKU
                </button>
                <button 
                    className={`px-4 sm:px-6 py-2.5 rounded-xl text-xs sm:text-sm font-bold transition-all whitespace-nowrap flex-shrink-0 ${
                        activeSettingsTab === 'suppliers' 
                            ? 'bg-emerald-500 text-white shadow-md' 
                            : 'text-slate-500 hover:text-slate-700'
                    }`} 
                    onClick={() => setActiveSettingsTab('suppliers')}
                >
                    Pengurusan Pembekal
                </button>
                <button 
                    className={`px-4 sm:px-6 py-2.5 rounded-xl text-xs sm:text-sm font-bold transition-all whitespace-nowrap flex-shrink-0 ${
                        activeSettingsTab === 'general' 
                            ? 'bg-emerald-500 text-white shadow-md' 
                            : 'text-slate-500 hover:text-slate-700'
                    }`} 
                    onClick={() => setActiveSettingsTab('general')}
                >
                    Butiran Projek
                </button>
            </div>

            {/* Tab Content */}
            {activeSettingsTab === 'sku' && (
                <SKUManagement
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    filteredInventory={filteredInventory}
                    priceLogs={priceLogs}
                    can={can}
                    setIsCategoryModalOpen={setIsCategoryModalOpen}
                    setSelectedItem={setSelectedItem}
                    setIsItemModalOpen={setIsItemModalOpen}
                    setViewingImage={setViewingImage}
                    setSelectedItemForPriceLog={setSelectedItemForPriceLog}
                    setShowPriceLogModal={setShowPriceLogModal}
                    requestConfirm={requestConfirm}
                    db={db}
                    fetchData={fetchData}
                />
            )}
            
            {activeSettingsTab === 'suppliers' && (
                <SupplierManagement
                    suppliers={suppliers}
                    setEditingSupplier={setEditingSupplier}
                    setIsSupplierModalOpen={setIsSupplierModalOpen}
                    requestConfirm={requestConfirm}
                    db={db}
                    fetchData={fetchData}
                />
            )}
            
            {activeSettingsTab === 'general' && (
                <ProjectDetails
                    activeProject={activeProject}
                    selectedProjectIcon={selectedProjectIcon}
                    setSelectedProjectIcon={setSelectedProjectIcon}
                    setConfirmModal={setConfirmModal}
                    db={db}
                    fetchData={fetchData}
                    showToast={showToast}
                    requestConfirm={requestConfirm}
                    can={can}
                    setIsDeleteProjectModalOpen={setIsDeleteProjectModalOpen}
                    setDeleteProjectPassword={setDeleteProjectPassword}
                    setDeleteProjectError={setDeleteProjectError}
                />
            )}
        </div>
    );
});

SettingsModule.displayName = 'SettingsModule';

export default SettingsModule;
